import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { WifiOff, RefreshCw } from 'lucide-react';
import { useAppStore } from '../../stores/appStore';
import { useWebSocket } from '../../hooks/useWebSocket';

const OfflineBanner = () => {
  const { t } = useTranslation();
  const { connectionStatus } = useAppStore();
  const { reconnect } = useWebSocket();

  const handleRetry = () => {
    if (connectionStatus === 'offline') {
      reconnect();
    }
  };

  return (
    <motion.div
      className="bg-red-500 text-white px-4 py-2 text-center text-sm font-medium"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -50, opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center justify-center space-x-2">
        {connectionStatus === 'reconnecting' ? (
          <>
            <RefreshCw className="w-4 h-4 animate-spin" />
            <span>{t('app.reconnecting')}</span>
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4" />
            <span>{t('app.offline')}</span>
            <button
              onClick={handleRetry}
              className="ml-2 px-2 py-1 bg-white bg-opacity-20 rounded text-xs hover:bg-opacity-30 transition-colors"
            >
              {t('common.retry')}
            </button>
          </>
        )}
      </div>
    </motion.div>
  );
};

export default OfflineBanner;